import React, { useRef } from 'react';
import AutosizeInput from 'react-input-autosize';
import { PercentBox, PercentSym } from './index.view';
import PropTypes from 'prop-types';
import { InputErrorMessage } from 'components/InputErrorMessage';
import { useTranslation } from 'react-i18next';

const AdaptPercentField = ({ input, meta, openAlert, onClose, ...rest }) => {
  const inputRef = useRef();
  const errorMsg = meta.error || meta.submitError;
  const { t } = useTranslation();
  const handleWarning = () => {
    return (
      openAlert && (
        <InputErrorMessage
          title={t('requiredPercentage')}
          msg={t('descriptionPercentage')}
          openAlert
          onClose={onClose}
        />
      )
    );
  };

  return (
    <>
      {errorMsg ? handleWarning() : null}
      <PercentBox
        onClick={() => {
          inputRef.current.focus();
        }}
      >
        <AutosizeInput
          {...input}
          {...rest}
          onFocus={(event) => {
            event?.target?.select();
            input.onFocus(event);
          }}
          ref={inputRef}
          minWidth={56}
          maxLength={12}
          placeholder="0"
        />
        <PercentSym>%</PercentSym>
      </PercentBox>
    </>
  );
};

AdaptPercentField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  openAlert: PropTypes.bool,
  onClose: PropTypes.func,
};

export default AdaptPercentField;
